import React, { Component } from "react";
import Button from "@mui/material/Button";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import withStyles from "@mui/styles/withStyles";
import PropTypes from "prop-types";
import ButtonGroup from "../Buttons/ButtonGroup";

const styles = () => ({
  arrowLeft: {
    transform: "rotate(180deg)"
  }
});

// TODO: make the content viewer navigation buttons reusable and use them instead of this component

class NavigationButtons extends Component {
  constructor(props) {
    super(props);
  }

  getNextActivityButton = () => {
    if (this.props.nextLink) {
      return (
        <Button
          color="primary"
          variant="outlined"
          onClick={this.props.onNextClick}
          endIcon={<ArrowRightAltIcon fontSize="large" />}
        >
          {"Next Resource"}
        </Button>
      );
    } else {
      return (
        <Button
          color="primary"
          variant="outlined"
          onClick={this.props.onExitClick}
          endIcon={<ExitToAppIcon fontSize="large" />}
        >
          {"Exit"}
        </Button>
      );
    }
  };

  getPrevActivityButton = () => {
    if (this.props.previousLink) {
      return (
        <Button
          color="primary"
          variant="outlined"
          onClick={this.props.onPreviousClick}
          startIcon={
            <ArrowRightAltIcon
              className={this.props.classes.arrowLeft}
              fontSize="large"
            />
          }
        >
          Prev Resource
        </Button>
      );
    }
    return null;
  };

  render() {
    return (
      <div>
        <ButtonGroup>
          {this.getPrevActivityButton()}
          {this.getNextActivityButton()}
        </ButtonGroup>
      </div>
    );
  }
}

export default withStyles(styles)(NavigationButtons);

NavigationButtons.propTypes = {
  previousLink: PropTypes.string,
  nextLink: PropTypes.string,
  onNextClick: PropTypes.func,
  onPreviousClick: PropTypes.func,
  onExitClick: PropTypes.func
};
